import React from "react";

export const SignupIdContext = React.createContext("");
